import React from "react";
import "./Result.css";
import { useNavigate } from "react-router-dom";
import Result_card from "./result_card/Result_card";
import Blue_border_button from "../../../../../common_components/common_btn/blue_border_button/Blue_border_button";

function Result() {
       const navigate = useNavigate();
  return (
    <>
      <section className="Result">
        {/* Header */}
        <div className="Result_header">
          <div className="heading_text_holder">
            <h1>Result</h1>
          </div>

          <div className="btn_holder">
            <Blue_border_button button_text="Restart Test"    onClick={() => navigate("/portal/student/language-test-step-form")}/>
          </div>
        </div>

        <div className="row">
            <div className="col-md-6 mb-3">
                <Result_card/>
            </div>

            <div className="col-md-6 mb-3">
                <Result_card/>
            </div>

            <div className="col-md-6 mb-3">
                <Result_card/>
            </div>

            <div className="col-md-6 mb-3">
                <Result_card/>
            </div>
        </div>
      </section>
    </>
  );
}

export default Result;
